module.exports = __webpack_public_path__ + "static/img/icon_dropdown_up.5550aae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_dropdown_up.svg
// module id = vu7y
// module chunks = 10